module.exports = __webpack_public_path__ + "img/2021.6153f7da.webp";